<template>
  <div class="property">
    <div class="property-top">
      <!-- <img src="@/assets/images/squirrelCup/2024/cupTwo/noUp.png" alt="" /> -->
      <div class="tip" @click="toRewardQuery">
        <img
          src="@/assets/images/squirrelCup/2024/cupTwo/rewardQuery.png"
          alt=""
          style="width: 32px;height: 32px;"
        />
        <van-badge class="margin-left-8">奖励发放记录</van-badge>
        <!-- <span class="yuan"><van-icon name="arrow" size="18" /></span> -->
        <div class="yuan">
          <img
            src="@/assets/images/squirrelCup/2024/cupTwo/next@2x.png"
            alt=""
          />
        </div>
      </div>
      <div class="tip" @click="toRevive">
        <img
          src="@/assets/images/squirrelCup/2024/cupTwo/request.png"
          alt=""
          style="width: 32px;height: 32px;"
        />
        <van-badge :content="totalNum" class="margin-left-8"> 复活请求 </van-badge>
        <!-- <span class="yuan"><van-icon name="arrow" size="18" /></span> -->
        <div class="yuan margin-left-34">
          <img
            src="@/assets/images/squirrelCup/2024/cupTwo/next@2x.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="topback">
      <div class="search-wrap">
        <van-search
          v-model="inputValue"
          shape="round"
          placeholder="请输入用户姓名、手机号、账号"
        />
        <div class="btn" @click="getData">搜索</div>
      </div>
    </div>
    <div class="listSty" v-if="rowInfos.length > 0">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        :offset="2"
        @load="onLoad"
      >
        <div
          class="listBody"
          v-for="(item, index) in rowInfos"
          :key="index"
          @click="toDetails(item)"
        >
          <div class="leftSty">
            <img :src="item.avatar" alt="" />
            <div class="content">
              <div class="top">
                <span>{{ item.name }}</span>
                <img
                  src="@/assets/images/squirrelCup/2024/cupTwo/reward.png"
                  alt=""
                />
                <span class="colSty" @click.stop="toExtra(item)">奖励</span>
              </div>
              <div class="text">{{ item.mobile }}</div>
            </div>
            <div class="nextArr"><van-icon name="arrow" size="18" /></div>
          </div>
        </div>
      </van-list>
    </div>
    <Empty :word="'暂无信息'" v-else></Empty>
  </div>
</template>
<script>
import { List, Cell, Search, Badge } from "vant";
import { getStudentInfoList, revivependingprocessing } from "@/api/squirrelCup";
import Empty from "./components/Empty.vue";

export default {
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Search.name]: Search,
    [Badge.name]: Badge,
    Empty,
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      inputValue: "",
      page: {
        pageIndex: 0,
        pageSize: 10,
      },
      total: "",
      rowInfos: [],
      totalNum: "",
    };
  },
  mounted() {
    this.onLoad();
    this.queryRevive();
    document.title ="道具箱"
  },
  methods: {
    getData() {
      this.page.pageIndex = 0;
      this.finished = false;
      this.rowInfos = [];
      this.onLoad();
    },
    queryRevive() {
      let pkParams = JSON.parse(localStorage.getItem("pkParams"));
      let userInfo = JSON.parse(localStorage.getItem("userInfoId"));
      let paramDat = {
        pageIndex: 1,
        pageSize: 10,
        param: {
          season_id: pkParams.lastSeasonTagId, //赛季ID
          service_id: pkParams.currentCampusId, //服务中心ID
          agentUserId: Number(userInfo.agentUserId),
        },
      };
      revivependingprocessing(paramDat).then((res) => {
        this.totalNum = res.data.count;
      });
    },
    getLoadLIst() {
      this.loading = true;
      let userInfo = JSON.parse(localStorage.getItem("userInfoId"));

      const postData = {
        ...this.page,
        param: {
          campusId: Number(userInfo.campusId),
          agentUserId: Number(userInfo.agentUserId),
          key: this.inputValue,
        },
      };
      getStudentInfoList(postData).then((res) => {
        console.log(res);
        this.total = res.data.count;
        this.rowInfos = this.rowInfos.concat(res.data.body);
        this.loading = false;
        // if (res.data.body.length  < 10) return (this.finished = true);

        if (this.rowInfos.length >= this.total) return (this.finished = true);
      });
      //
    },
    onLoad() {
      this.page.pageIndex++;
      this.getLoadLIst();
    },
    toDetails(info) {
      this.$router.push({
        path: "/winterGame/property/details",
        query: {
          // infoObj: JSON.stringify(info),
          accountId: info.accountId,
        },
      });
      localStorage.setItem("headInfo", JSON.stringify(info));
    },
    toExtra(info) {
      // 加时卡
      this.$router.push("/winterGame/extra");
      localStorage.setItem("headInfo", JSON.stringify(info));
    },
    toRevive() {
      this.$router.push("/winterGame/revive");
    },
    toRewardQuery() {
      this.$router.push("/winterGame/rewardQuery");
    }
  },
};
</script>
<style lang="less" scoped>
.margin-left-8 {
  margin-left: 8px;
}
.margin-left-34 {
  margin-left: 34px !important;
}
.property {
  overflow: hidden;
  background: #f6f9fd;
  height: 100vh;
  &-top {
    display: flex;
    font-size: 28px;
    color: #58abf6;
    justify-content: space-between;
    background: #fff;
    padding: 12px 32px;
    height: 120px;
    position: relative;
    // background: linear-gradient(136deg, #f2f9ff 0%, #ddefff 100%);
    img {
      width: 39px;
      height: 39px;
    }

    .tip {
      width: 48%;
      height: 100%;
      background: linear-gradient( 136deg, #F2F9FF 0%, #DDEFFF 100%);
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      /deep/.van-badge--fixed {
        right: -14px;
      }
    }
    .yuan {
      margin-left: 8px;
      img {
        width: 48px;
        height: 48px;
        // margin-left: 34px;
      }
    }
  }
  .topback {
    padding-top: 16px;
    background: #fff;
    padding-bottom: 32px;
  }
  .search-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;

    /deep/ .van-search {
      width: 100%;
      padding: 0px 32px;

      .van-search__content {
        background: #fff;
        border: 1px solid #e6e6e6;
      }
    }
    .btn {
      position: absolute;
      right: 40px;
      top: 50%;
      width: 160px;
      height: 56px;
      background: #58abf6;
      border-radius: 28px;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 56px;
      text-align: center;
      transform: translateY(-50%);
    }
  }
  .listSty {
    height: calc(100vh - 260px);
    overflow: auto;
    width: 100%;
    padding: 0px 32px;
    margin-top: 16px;
  }
  .listBody {
    display: flex;
    padding: 40px 32px 32px 32px;
    border-bottom: 1px solid #e6e6e6;
    background: #fff;
    margin-bottom: 16px;
    border-radius: 16px;
    .leftSty {
      display: flex;
      align-items: center;
      font-size: 32px;
      color: #323232;
      font-weight: bold;
      width: 100%;
      position: relative;
      img {
        width: 96px;
        height: 96px;
        border-radius: 50%;
        margin-right: 32px;
        object-fit: contain;
      }
      .content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .top {
          display: flex;
          align-items: center;
          padding-bottom: 8px;
        }
        img {
          width: 32px;
          height: 32px;
          margin: 0;
          margin-left: 24px;
          margin-right: 6px;
          border-radius: 0;
        }
        .colSty {
          font-size: 24px;
          color: #58abf6;
          text-decoration: underline;
        }
        .text {
          font-size: 24px;
          font-weight: 400;
          color: #999999;
        }
      }
      .nextArr {
        position: absolute;
        right: 2px;
        bottom: 6px;
        color: #58abf6;
      }
    }
  }
}
</style>
